<template>
  <div
    id="RegisterPage"
    class="register-page"
    :class="{
      'register-page--auth': (stage == 1 || stage == 2) && Islogin == undefined,
      'register-page--membership': stage == 3 || Islogin == true,
    }"
    dir="rtl"
  >
    <div
      v-if="(stage == 1 || stage == 2) && Islogin == undefined"
      class="register-glow register-glow--primary"
      aria-hidden="true"
    ></div>
    <div
      v-if="(stage == 1 || stage == 2) && Islogin == undefined"
      class="register-glow register-glow--secondary"
      aria-hidden="true"
    ></div>
    <loading v-if="loadingRender"></loading>
    <div
      v-if="stage == 1 && Islogin == undefined"
      class="register-auth-page register-auth-page--themed no-print"
    >
      <panel
        Title="احراز هویت"
        Des=""
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="register-card-shell register-card-shell--auth">
        <net-pa-card class="register-form-card">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-user-plus"></i>
              احراز هویت
            </h6>
          </template>
          <template slot="content">
            <div class="register-auth-panel">
              <div class="register-auth-intro">
                <h6 v-if="IsEstelamCodeMeli == 'false'" class="mb-2">
                  برای دریافت کد احراز هویت کد ملی و شماره موبایل خود را وارد
                  کنید.
                </h6>
                <h6 v-if="IsEstelamCodeMeli == 'true'" class="mb-2">
                  برای دریافت کد احراز هویت کد ملی ، شماره موبایل و تاریخ تولد
                  خود را وارد کنید.
                </h6>
                <span
                  v-if="IsEstelamCodeMeli == 'true'"
                  class="register-auth-warning d-block"
                >
                  برای احراز هویت شما نیاز است شماره موبایل و تاریخ تولد شما با
                  اطلاعات واقعی شما مطابقت داشته باشد
                </span>
              </div>
              <form id="div1" class="register-auth-form w-100">
                <div class="row">
                  <div class="col-12 register-auth-field">
                    <label
                      class="register-auth-label"
                      for="register-stage1-codemeli"
                      >کد ملی</label
                    >
                    <input
                      id="register-stage1-codemeli"
                      class="form-control text-center required required-CodeMeli register-auth-input"
                      style="direction: ltr"
                      type="number"
                      v-model="CodeMeli"
                      placeholder="کد ملی"
                    />
                  </div>
                  <div
                    :class="
                      IsEstelamCodeMeli == 'true' ? 'col-lg-6 col-12' : 'col-12'
                    "
                    class="register-auth-field"
                  >
                    <label
                      class="register-auth-label"
                      for="register-stage1-mobile"
                      >شماره موبایل</label
                    >
                    <input
                      id="register-stage1-mobile"
                      class="form-control text-center required register-auth-input"
                      style="direction: ltr"
                      type="number"
                      v-model="Mobile"
                      placeholder="شماره موبایل "
                    />
                  </div>
                  <div
                    :class="
                      IsEstelamCodeMeli == 'true' ? 'col-lg-6 col-12' : 'col-12'
                    "
                    class="register-auth-field"
                    v-if="IsEstelamCodeMeli == 'true'"
                  >
                    <label class="register-auth-label">تاریخ تولد</label>
                    <date-picker
                      input-class="required form-control register-auth-input"
                      v-model="BirthDate"
                      :editable="true"
                      color="#05b8c8"
                      placeholder="تاریخ تولد"
                    ></date-picker>
                  </div>
                  <div
                    class="col-12 register-auth-field register-auth-field--captcha"
                  >
                    <span class="register-auth-label">کد امنیتی</span>
                    <CaptchaBox
                      ref="captchaRef"
                      @update="onCaptchaValid"
                    ></CaptchaBox>
                  </div>
                  <div class="col-12 register-auth-actions">
                    <button
                      :disabled="!CaptchaValid"
                      class="btn btn-submit w-100 register-auth-submit-btn"
                      @click.prevent="sendSms"
                    >
                      {{
                        IsEstelamCodeMeli == "true"
                          ? " احراز هویت"
                          : "ارسال پیامک"
                      }}
                    </button>
                  </div>
                  <div
                    v-if="$session.get('CustCode') == '932'"
                    class="col-12 register-auth-actions"
                  >
                    <button
                      class="btn btn-info w-100 register-auth-secondary-btn"
                      @click.prevent="Check()"
                    >
                      پیگیری درخواست
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>

    <div
      v-else-if="stage == 2 && Islogin == undefined"
      class="register-auth-page register-auth-page--themed no-print"
    >
      <panel
        Title="احراز هویت"
        Des=""
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="register-card-shell register-card-shell--auth">
        <net-pa-card class="register-form-card">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-user-plus"></i>
              احراز هویت
            </h6>
          </template>
          <template slot="content">
            <div class="register-auth-panel">
              <div class="register-auth-intro mb-3">
                <h6 class="mb-0">
                  کد ارسالی شرکت نو اندیش پاسارگاد به شماره تلفن همراهتان را جهت
                  احراز هویت وارد نمائید
                </h6>
              </div>
              <div class="register-auth-form">
                <div class="register-auth-field">
                  <label class="register-auth-label" for="txtRandoKey"
                    >کد احراز هویت</label
                  >
                  <input
                    v-if="IsEstelamCodeMeli == 'false'"
                    type="number"
                    placeholder="کد احراز هویت"
                    class="form-control text-center register-auth-input"
                    style="direction: ltr"
                    v-model="randomKey"
                    autocomplete="off"
                    maxlength="6"
                    id="txtRandoKey"
                  />
                  <input
                    v-if="IsEstelamCodeMeli == 'true'"
                    type="number"
                    placeholder="کد احراز هویت را وارد کنید"
                    class="form-control text-center register-auth-input"
                    style="direction: ltr"
                    v-model="randomKey"
                    autocomplete="off"
                    id="txtRandoKey"
                  />
                </div>
                <div class="register-auth-field register-auth-field--captcha">
                  <span class="register-auth-label">کد امنیتی</span>
                  <CaptchaBox
                    ref="captchaRef3"
                    @update="onCaptchaValid3"
                  ></CaptchaBox>
                </div>
                <div class="register-auth-actions">
                  <button
                    class="btn w-100 btn-submit register-auth-submit-btn"
                    :disabled="!CaptchaValid3"
                    @click="OkCode()"
                  >
                    ثبت کد
                  </button>
                </div>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>

    <div
      v-else-if="stage == 3 || Islogin == true"
      class="register-membership-page register-membership-page--solo register-membership-page--themed no-print"
    >
      <panel
        Title="درخواست عضویت"
        Des=""
        :IsBtnBack="true"
        ClassCustom="bg-dark-Custom text-right mt-2"
      ></panel>
      <div class="register-card-shell register-card-shell--membership">
        <net-pa-card class="register-form-card">
          <template slot="header">
            <h6 class="text-right">
              <i class="fas fa-id-card"></i>
              درخواست عضویت
            </h6>
          </template>
          <template slot="content">
            <div class="register-membership-body text-right">
              <form id="Register">
                <section class="register-membership-section">
                  <h6 class="register-membership-section__title">
                    <i class="fas fa-user" aria-hidden="true"></i>
                    <span>اطلاعات فردی</span>
                  </h6>
                  <div class="register-membership-fields">
                    <label class="register-membership-field">
                      <span class="register-membership-label">نام</span>
                      <input
                        autocomplete="off"
                        @keypress="$ValidPersian($event, 20)"
                        type="text"
                        id="OzvName"
                        class="form-control InputText required"
                        v-model="OzvName"
                        :disabled="FixInput == true"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label"
                        >نام خانوادگی</span
                      >
                      <input
                        autocomplete="off"
                        @keypress="$ValidPersian($event, 40)"
                        type="text"
                        id="OzvFamily"
                        class="form-control InputText required"
                        v-model="OzvFamily"
                        :disabled="FixInput == true"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">کد ملی</span>
                      <input
                        autocomplete="off"
                        type="number"
                        maxlength="10"
                        class="form-control InputText required-CodeMeli text-left"
                        @keypress="$ValidNumber($event, 10)"
                        @input="$CheckupLengthCodeMeli($event)"
                        v-model="CodeMeli"
                        :disabled="Islogin == undefined || FixInput == true"
                      />
                    </label>
                    <div class="register-membership-field">
                      <span class="register-membership-label">تاریخ تولد</span>
                      <date-picker
                        :editable="true"
                        v-model="BirthDate"
                        color="#287db4"
                      ></date-picker>
                      <input
                        type="text"
                        tabindex="-1"
                        class="d-none InputText required"
                        v-model="BirthDate"
                        style="direction: ltr"
                      />
                    </div>
                    <label class="register-membership-field">
                      <span class="register-membership-label"
                        >شماره شناسنامه</span
                      >
                      <input
                        autocomplete="off"
                        type="number"
                        maxlength="10"
                        @keypress="$ValidNumber($event, 10)"
                        v-model="Shenasname"
                        id="Shenasname"
                        class="form-control InputText required"
                        style="direction: ltr"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">نام پدر</span>
                      <input
                        autocomplete="off"
                        v-model="Pedar"
                        type="text"
                        @keypress="$ValidPersian($event, 50)"
                        id="pedar"
                        class="form-control text-right InputText required"
                        style="direction: rtl"
                        :disabled="FixInput == true"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">جنسیت</span>
                      <select
                        class="form-control Pointer required"
                        id="cmbSEX"
                        v-model="cmbSEX"
                        :disabled="FixInput == true"
                      >
                        <option selected class="Pointer" :value="4041">
                          مرد
                        </option>
                        <option class="Pointer" :value="4042">زن</option>
                      </select>
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">وضعیت تاهل</span>
                      <select
                        class="form-control Pointer required"
                        id="cmbTaahol"
                        v-model="cmbTaahol"
                      >
                        <option selected class="Pointer" :value="4068">
                          مجرد
                        </option>
                        <option class="Pointer" :value="4067">متاهل</option>
                      </select>
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label"
                        >محل صدور شناسنامه</span
                      >
                      <input
                        autocomplete="off"
                        v-model="Sodor"
                        type="text"
                        @keypress="$ValidPersian($event, 50)"
                        id="Sodor"
                        class="form-control text-right InputText required"
                        style="direction: rtl"
                      />
                    </label>
                    <label
                      class="register-membership-field"
                      v-if="$session.get('CustCode') == '932'"
                    >
                      <span class="register-membership-label"
                        >شماره پرسنلی / مستمری</span
                      >
                      <input
                        autocomplete="off"
                        v-model="PerNo"
                        type="text"
                        @keypress="$ValidNumber($event, 10)"
                        id="PerNo"
                        class="form-control text-right InputText required"
                        style="direction: rtl"
                      />
                    </label>
                    <label
                      v-if="$session.get('CustCode') == '932'"
                      class="register-membership-field register-membership-field--full"
                    >
                      <span class="register-membership-label"
                        >از کجا با ما آشنا شده‌اید؟</span
                      >
                      <input
                        class="form-control required"
                        type="text"
                        v-model="moaref"
                      />
                    </label>
                  </div>
                </section>
                <section class="register-membership-section">
                  <h6 class="register-membership-section__title">
                    <i class="fas fa-phone-alt" aria-hidden="true"></i>
                    <span>اطلاعات تماس</span>
                  </h6>
                  <div class="register-membership-fields">
                    <label class="register-membership-field">
                      <span class="register-membership-label">شماره همراه</span>
                      <input
                        autocomplete="off"
                        type="number"
                        @keypress="$ValidNumber($event, 11)"
                        id="Mobile"
                        class="form-control InputText required"
                        style="direction: ltr"
                        v-model="Mobile"
                        :disabled="Islogin == undefined || FixInput == true"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">تلفن تماس</span>
                      <input
                        autocomplete="off"
                        type="number"
                        @keypress="$ValidNumber($event, 11)"
                        id="Tel"
                        class="form-control InputText"
                        :class="{ required: $session.get('CustCode') == '948' }"
                        style="direction: ltr"
                        v-model="Tel"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">کد پستی</span>
                      <input
                        autocomplete="off"
                        type="number"
                        @keypress="$ValidNumber($event, 10)"
                        id="CodePosti"
                        class="form-control InputText required"
                        style="direction: ltr"
                        v-model="CodePosti"
                      />
                    </label>
                    <label
                      class="register-membership-field register-membership-field--full"
                    >
                      <span class="register-membership-label">آدرس منزل</span>
                      <textarea
                        autocomplete="off"
                        type="text"
                        id="Address"
                        class="form-control InputText text-right"
                        :class="{ required: $session.get('CustCode') == '948' }"
                        rows="2"
                        style="direction: rtl"
                        v-model="Address"
                      ></textarea>
                    </label>
                  </div>
                </section>
                <section
                  v-if="
                    $session.get('CustCode') != '953' &&
                    $session.get('CustCode') != '948'
                  "
                  class="register-membership-section register-membership-section--split"
                >
                  <h6 class="register-membership-section__title">
                    <i class="fas fa-university" aria-hidden="true"></i>
                    <span>اطلاعات بانکی</span>
                  </h6>
                  <div class="register-membership-fields">
                    <label
                      v-if="$session.get('CustCode') == '953'"
                      class="register-membership-field"
                    >
                      <span class="register-membership-label"
                        >شماره حساب بانکی</span
                      >
                      <input
                        autocomplete="off"
                        type="number"
                        @keypress="$ValidNumber($event, 20)"
                        id="Mobile"
                        class="form-control InputText"
                        style="direction: ltr"
                        v-model="HesabNo"
                      />
                    </label>
                    <label v-else class="register-membership-field">
                      <span class="register-membership-label"
                        >شماره حساب بانکی</span
                      >
                      <input
                        autocomplete="off"
                        type="number"
                        @keypress="$ValidNumber($event, 14, false)"
                        id="Mobile"
                        class="form-control InputText required"
                        style="direction: ltr"
                        v-model="HesabNo"
                      />
                    </label>
                    <label class="register-membership-field">
                      <span class="register-membership-label">انتخاب بانک</span>
                      <select
                        name="cmbBank"
                        id="cmbBank"
                        class="form-control Pointer"
                        v-model="ResultcmbBank"
                      >
                        <option
                          selected
                          v-for="item in this.ListModelBank"
                          :key="item.id"
                          :value="item.bnpCashDbtblBankId"
                        >
                          <span>{{ item.bankName }}</span>
                        </option>
                      </select>
                    </label>
                  </div>
                </section>
                <section class="register-membership-section">
                  <h6 class="register-membership-section__title">
                    <i class="fas fa-info-circle" aria-hidden="true"></i>
                    <span>سایر اطلاعات</span>
                  </h6>
                  <div class="register-membership-fields">
                    <div
                      class="register-membership-field register-membership-field--full"
                    >
                      <span
                        v-if="$session.get('CustCode') == '801'"
                        class="register-membership-label"
                      >
                        شعبه مورد نظر جهت عضویت
                      </span>
                      <span v-else class="register-membership-label">
                        {{ txtTafsilytype }}
                      </span>
                      <div
                        v-if="Islogin == undefined"
                        class="register-membership-dropdown-wrap"
                      >
                        <Dropdown
                          :options="OptionsvalidateSelection2"
                          v-on:selected="validateSelectionShobe"
                          name="TafsiliType"
                          :maxItem="50000"
                          :disabled="false"
                          placeholder="انتخاب کنید"
                        >
                        </Dropdown>
                      </div>
                      <div v-else class="register-membership-field-value">
                        {{ nameTafsiliType }}
                      </div>
                    </div>
                    <div
                      v-if="$session.get('CustCode') == '932'"
                      class="register-membership-field register-membership-field--full"
                    >
                      <span class="register-membership-label">
                        نوع اداره کل بیمه یا درمان
                      </span>
                      <div class="register-membership-dropdown-wrap">
                        <Dropdown
                          :options="OptionsvalidateSelection4"
                          v-on:selected="validateSelectionJob"
                          :disabled="false"
                          name="Job"
                          :maxItem="50000"
                          placeholder="انتخاب کنید"
                        >
                        </Dropdown>
                      </div>
                    </div>
                    <div
                      v-if="$session.get('CustCode') == '932'"
                      class="register-membership-field register-membership-field--full"
                    >
                      <span class="register-membership-label">
                        استان مورد نظر جهت عضویت
                      </span>
                      <div class="register-membership-dropdown-wrap">
                        <Dropdown
                          :options="OptionsvalidateSelection3"
                          v-on:selected="validateSelectionOstan"
                          :disabled="false"
                          name="grp325"
                          :maxItem="50000"
                          placeholder="انتخاب کنید"
                        >
                        </Dropdown>
                      </div>
                    </div>
                    <div
                      class="register-membership-field register-membership-field--full"
                    >
                      <span
                        v-if="$session.get('CustCode') == '801'"
                        class="register-membership-label"
                      >
                        محل کار مورد نظر جهت عضویت
                      </span>
                      <span v-else class="register-membership-label">
                        {{ txtAzaNo }}
                      </span>
                      <div
                        v-if="Islogin == undefined"
                        class="register-membership-dropdown-wrap"
                      >
                        <Dropdown
                          :options="OptionsvalidateSelection"
                          v-on:selected="validateSelection"
                          :disabled="false"
                          name="zipcode"
                          :maxItem="50000"
                          placeholder="انتخاب کنید"
                        >
                        </Dropdown>
                      </div>
                      <div v-else class="register-membership-field-value">
                        {{ nameAzanoe }}
                      </div>
                    </div>
                    <div
                      class="register-membership-field register-membership-field--full"
                      v-if="
                        $session.get('CustCode') != '932' &&
                        $session.get('CustCode') != '953' &&
                        $session.get('CustCode') != '948' &&
                        $session.get('CustCode') != '8002'
                      "
                    >
                      <span class="register-membership-label"
                        >عضویت به عنوان</span
                      >
                      <div class="register-membership-radio-group">
                        <div
                          class="custom-control custom-radio custom-control-inline register-membership-radio"
                        >
                          <input
                            type="radio"
                            id="customRadioInline1"
                            name="customRadioInline"
                            class="custom-control-input"
                            @click="changeRdo"
                            :checked="rdoAsli && Islogin == undefined"
                            :disabled="Islogin"
                          />
                          <label
                            class="custom-control-label"
                            for="customRadioInline1"
                            >عضو اصلی</label
                          >
                        </div>
                        <div
                          class="custom-control custom-radio custom-control-inline register-membership-radio"
                        >
                          <input
                            type="radio"
                            id="customRadioInline2"
                            name="customRadioInline"
                            class="custom-control-input"
                            @click="changeRdo"
                            :checked="Islogin"
                          />
                          <label
                            class="custom-control-label"
                            for="customRadioInline2"
                            >عضو وابسته</label
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      v-if="IsVabaste != ''"
                      class="register-membership-field register-membership-field--full register-membership-field--codemeli"
                    >
                      <span class="register-membership-label"
                        >کد ملی عضو اصلی</span
                      >
                      <div class="register-membership-codemeli-check">
                        <input
                          autocomplete="off"
                          type="number"
                          maxlength="10"
                          class="form-control InputText required-CodeMeli text-left"
                          @keypress="$ValidNumber($event, 10)"
                          @input="$CheckupLengthCodeMeli($event)"
                          v-model="CodeMeliVabaste"
                          :disabled="Islogin"
                        />
                        <button
                          class="sv-btn sv-btn--primary register-membership-codemeli-check__btn"
                          @click="CheckCodemeli()"
                          type="button"
                          id="button-addon1"
                        >
                          بررسی
                        </button>
                      </div>
                      <p class="register-membership-codemeli-result">
                        <span>مشخصات عضو اصلی:</span>
                        {{ Moshakhasat }}
                      </p>
                    </div>
                  </div>
                </section>
                <section
                  v-if="$session.get('CustCode') != '948'"
                  class="register-membership-section"
                >
                  <h6 class="register-membership-section__title">
                    <i class="fas fa-file-upload" aria-hidden="true"></i>
                    <span>آپلود مدارک</span>
                  </h6>
                  <div class="register-membership-docs-note">
                    <i class="fas fa-info-circle" aria-hidden="true"></i>
                    <p>
                      فرمت قابل قبول برای ارسال مدارک gif و jpg و jpeg و png و
                      zip و rar و pdf
                    </p>
                    <p
                      v-if="
                        $cookies.isKey('RegisterForm') &
                        ($session.get('CustCode') == 886)
                      "
                    >
                      برای دانلود فرم عضویت
                      <a
                        :href="$cookies.get('RegisterForm')"
                        download="فرم عضویت"
                        >اینجا</a
                      >
                      کلیک کنید.
                    </p>
                  </div>
                  <div
                    class="register-membership-upload-area"
                    v-if="
                      $session.get('CustCode') != 932 &&
                      $session.get('CustCode') != 953
                    "
                  >
                    <input
                      type="file"
                      @change="changefile(null, $event)"
                      class="d-none"
                      id="Uploader"
                      accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                    />
                    <p
                      v-if="$session.get('CustCode') == 860"
                      class="register-membership-upload-hint"
                    >
                      بارگذاری اسکن کارت ملی، شناسنامه و عکس پرسنلی در یک فایل
                      zip الزامی است
                    </p>
                    <button
                      class="sv-btn sv-btn--primary register-membership-upload-btn"
                      @click.prevent="clickUploader('')"
                    >
                      <i class="fas fa-cloud-upload-alt" aria-hidden="true"></i>
                      برای بارگذاری مدارک کلیک کنید
                    </button>
                    <div
                      v-if="fileinfo.name"
                      class="register-membership-upload-result"
                    >
                      <i class="fas fa-check-circle" aria-hidden="true"></i>
                      <span>فایل بارگذاری شده:</span>
                      <b>{{ fileinfo.name }}</b>
                    </div>
                  </div>

                  <div class="register-membership-upload-grid" v-else>
                    <div class="register-membership-upload-card">
                      <div class="register-membership-upload-card__title">
                        تصویر روی کارت ملی
                      </div>
                      <input
                        type="file"
                        @change="changefile(1, $event)"
                        class="d-none"
                        :key="RenderFile1"
                        id="Uploader1"
                        accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      />
                      <div class="register-membership-upload-card__actions">
                        <button
                          class="sv-btn sv-btn--ghost sv-btn--icon"
                          @click.prevent="
                            fileinfo1 = {};
                            RenderFile1++;
                          "
                          v-if="fileinfo1.name"
                          type="button"
                          title="حذف فایل"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="sv-btn sv-btn--primary"
                          @click.prevent="clickUploader(1)"
                          type="button"
                        >
                          {{
                            fileinfo1.name
                              ? "بارگذاری مجدد فایل"
                              : "بارگذاری فایل"
                          }}
                        </button>
                      </div>
                      <div
                        class="register-membership-upload-card__meta"
                        v-if="fileinfo1.name"
                      >
                        <span>{{ fileinfo1.name }}</span>
                        <span v-if="fileinfo1.size">
                          {{ (fileinfo1.size / 1000000).toFixed(2) }} MB
                        </span>
                      </div>
                    </div>
                    <div class="register-membership-upload-card">
                      <div class="register-membership-upload-card__title">
                        صفحه اول شناسنامه
                      </div>
                      <input
                        type="file"
                        @change="changefile(2, $event)"
                        class="d-none"
                        :key="RenderFile2"
                        id="Uploader2"
                        accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      />
                      <div class="register-membership-upload-card__actions">
                        <button
                          class="sv-btn sv-btn--ghost sv-btn--icon"
                          @click.prevent="
                            fileinfo2 = {};
                            RenderFile2++;
                          "
                          v-if="fileinfo2.name"
                          type="button"
                          title="حذف فایل"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="sv-btn sv-btn--primary"
                          @click.prevent="clickUploader(2)"
                          type="button"
                        >
                          {{
                            fileinfo2.name
                              ? "بارگذاری مجدد فایل"
                              : "بارگذاری فایل"
                          }}
                        </button>
                      </div>
                      <div
                        class="register-membership-upload-card__meta"
                        v-if="fileinfo2.name"
                      >
                        <span>{{ fileinfo2.name }}</span>
                        <span v-if="fileinfo2.size">
                          {{ (fileinfo2.size / 1000000).toFixed(2) }} MB
                        </span>
                      </div>
                    </div>
                    <div class="register-membership-upload-card">
                      <div class="register-membership-upload-card__title">
                        حکم کارگزینی/مستمری/بازماندگی
                      </div>
                      <input
                        type="file"
                        @change="changefile(3, $event)"
                        class="d-none"
                        :key="RenderFile3"
                        id="Uploader3"
                        accept=".gif,.jpg,.jpeg,.png,.zip,.rar,.pdf"
                      />
                      <div class="register-membership-upload-card__actions">
                        <button
                          class="sv-btn sv-btn--ghost sv-btn--icon"
                          @click.prevent="
                            fileinfo3 = {};
                            RenderFile3++;
                          "
                          v-if="fileinfo3.name"
                          type="button"
                          title="حذف فایل"
                        >
                          <i class="fas fa-trash"></i>
                        </button>
                        <button
                          class="sv-btn sv-btn--primary"
                          @click.prevent="clickUploader(3)"
                          type="button"
                        >
                          {{
                            fileinfo3.name
                              ? "بارگذاری مجدد فایل"
                              : "بارگذاری فایل"
                          }}
                        </button>
                      </div>
                      <div
                        class="register-membership-upload-card__meta"
                        v-if="fileinfo3.name"
                      >
                        <span>{{ fileinfo3.name }}</span>
                        <span v-if="fileinfo3.size">
                          {{ (fileinfo3.size / 1000000).toFixed(2) }} MB
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="register-membership-terms"
                    v-if="$session.get('CustCode') == 932"
                  >
                    <input type="checkbox" v-model="AcceptGhavnin932" />
                    <span>
                      اینجانب
                      <u
                        class="Pointer"
                        data-toggle="modal"
                        data-target="#Modal-light"
                      >
                        شرایط و ضوابط
                      </u>
                      تعاونی اعتبار را مطالعه و پذیرفته‌ام
                    </span>
                  </div>
                </section>
              </form>
              <div class="register-membership-actions">
                <div class="register-membership-actions__captcha">
                  <CaptchaBox
                    ref="captchaRef2"
                    @update="onCaptchaValid2"
                  ></CaptchaBox>
                </div>
                <button
                  v-if="state == 1"
                  :disabled="!CaptchaValid2"
                  class="sv-btn sv-btn--primary sv-btn--wide"
                  @click="SabtOzv()"
                >
                  ثبت اطلاعات
                </button>
                <button
                  v-if="state == 2"
                  class="sv-btn sv-btn--primary sv-btn--wide"
                  @click="EditOzv()"
                >
                  ویرایش اطلاعات
                </button>
              </div>
            </div>
          </template>
        </net-pa-card>
      </div>
    </div>
    <modal-custom>
      <template v-slot:ContentModalLight>
        <div class="container text-justify">
          <div class="text-center alert alert-secondary">
            <b
              >شرایط و ضوابط تعاونی اعتبار کارکنان سازمان تامین اجتماعی ( تکتا )
            </b>
          </div>
          <li class="mt-4" style="word-break: break-word">
            اعضا یک ماه پس از تکمیل مبلغ اولیه سهام ( یک میلیون تومان ) به حساب
            تعاونی اعتبار ، می توانند نسبت به سپرده گذاری اقدام نمایند.
          </li>
          <li class="mt-4" style="word-break: break-word">
            عضو تکتا به سازمان تامین اجتماعی اجازه می دهد که تعاونی اعتبار مبلغ
            پس انداز ماهیانه( 6/000/000 ريال ) و در صورت دریافت تسهیلات ،اقساط
            آن را از حقوق یا مستمری ماهیانه وی کسر و به حساب تعاونی اعتبار واریز
            نماید.
          </li>
          <li class="mt-3" style="word-break: break-word">
            چنانچه در سنوات آتی، مجمع عمومی تعاونی اعتبار مبلغ پرداخت مستمر پس
            انداز ماهیانه( 6/000/000 ريال ) را افزایش دهد موافقت خویش را با
            افزیش آن اعلام می دارم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            از شرایط و مبالغ کسر پس انداز ماهیانه و دریافت تسهیلات و پرداخت
            اقساط اطلاع دارم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            تمامی مطالبات اعم از(پس اندازهای کسر شده و مبلغ خرید سهام) در زمان
            انصراف به حساب سهامدار مسترد می گردد.
          </li>
          <li class="mt-3" style="word-break: break-word">
            مسؤلیت صحیح بودن اطلاعات ثبت شده در هنگام ثبت‌نام به عهده‌ی شخص
            کاربر خواهد بود.
          </li>
          <li class="mt-3" style="word-break: break-word">
            در مورد اطلاع از وضعیت ثبت نام،کد پیگیری توسط تکتا به شماره همراه
            شما ارسال خواهد شد، در صفحه نخست وب سایت به قسمت پیگیری، مراجعه
            نمائید. همچنین پس از ثبت نام شما در وب‌سایت، و تائیدیه کارشناسان
            مربوطه، پیامکی مبنی بر ثبت موفق اطلاعات شما درتعاونی اعتبار و آدرس
            کانال های ارتباطی جهت عضویت، ارسال خواهد شد.
          </li>
          <li class="mt-3" style="word-break: break-word">
            با توجه به الزامی بودن ثبت اطلاعات شما برای تکمیل فرایند ثبت نام، وب
            سایت تعاونی اعتبار امنیت اطلاعات خصوصی شما را تضمین و در جهت حفظ و
            نگهداری اطلاعات خصوصی افراد تلاش می‌نماید.
          </li>
          <li class="mt-3" style="word-break: break-word">
            همچنین متعهد میگردم که در هیچ یک از تعاونی اعتبار دیگری عضو نمیباشم.
          </li>
          <li class="mt-3" style="word-break: break-word">
            اعضاء یکماه پس از تاریخ عضویت، می توانند نسبت به سپرده گذاری اقدام
            نمایند
          </li>
          <p class="mt-5 text-center text-dark font-weight-bold">
            (( اینجانب موارد ذکر شده را مطالعه نموده و موافقت خود را در جهت
            اقدامات مربوطه اعلام می دارم ))
          </p>
          <div class="mb-5">
            <button
              class="btn btn-success float-left mb-5 rounded"
              data-dismiss="modal"
            >
              قوانین را مطالعه کردم
            </button>
          </div>
        </div>
      </template>
    </modal-custom>
  </div>
</template>
<script>
import NetPaCard from "../Tools/NetPa/NetPaCard.vue";
import Panel from "../Tools/NetPa/Panel.vue";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import loading from "../Tools/NetPa/Loading.vue";
import Dropdown from "vue-simple-search-dropdown";
import JSZip from "jszip";
import ModalCustom from "../Tools/ModalCustom.vue";
import CaptchaBox from "../CmpLogin/CaptchaBox.vue";
export default {
  data() {
    return {
      CodePosti: "",
      captchaText3: "",
      captchaId3: "",
      CaptchaValid3: false,
      captchaText2: "",
      captchaId2: "",
      CaptchaValid2: false,
      captchaText: "",
      captchaId: "",
      CaptchaValid: false,
      txtAzaNo: "دسته بندی",
      txtTafsilytype:
        this.$session.get("CustCode") == "932" ? "وضعیت اشتغال " : "نوع عضویت",
      stage: 1,
      OzvName: "",
      OzvFamily: "",
      CodeMeli: null,
      BirthDate: "",
      Shenasname: null,
      Pedar: "",
      cmbSEX: null,
      cmbTaahol: null,
      Sodor: "",
      PerNo: null,
      Mobile: "",
      Tel: null,
      Work: "",
      Address: "",
      cmbShobe: null,
      ResultcmbcmbAzaNoeArray: null,
      IsLoad: false,
      ListModelAzaNoe: null,
      loadingRender: false,
      DataAxios: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/NewAzaNetPa",
        Token: "",
      },
      DataAxiosEdit: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/UpdateNewAzaNetPa",
        Token: "",
      },
      DataAxiosUpload: {
        ArryfildValue: "",
        Method: "Post",
        Action: "EftetahHesab/SaveAttachmentToDb",
        Token: "",
      },
      rdoAsli: true,
      CodeMeliVabaste: "",
      IsVabaste: false,
      Moshakhasat: "",
      wwwtblAzaIdSahebHesab: null,
      ListModelTafsiliType: null,
      ResultcmbcmbTafsiliType: null,
      ResultcmbGrp325: null,
      fileinfo: {},
      fileinfo1: {},
      fileinfo2: {},
      fileinfo3: {},
      fileinfo1Isedit: false,
      fileinfo2Isedit: false,
      fileinfo3Isedit: false,
      RenderFile1: 0,
      RenderFile2: 0,
      RenderFile3: 0,
      OptionsvalidateSelection: [],
      OptionsvalidateSelection2: [],
      OptionsvalidateSelection3: [],
      OptionsvalidateSelection4: [],
      ListModelTafsily: null,
      ListModelBank: null,
      ResultcmbBank: null,
      HesabNo: 0,
      randomKey: "",
      bnpCashDbtblTafsiliTypeId: null,
      nameTafsiliType: "",
      nameAzanoe: "",
      IdEftetah: 0,
      ResultEstelamCodeMeli: {},
      MsgEstelamCodeMeli: "",
      EstelamCodeMeli: {},
      FixInput: false,
      FileZip: "",
      MultiFile: false,
      state: 1,
      AcceptGhavnin932: false,
      moaref: "",
      wwwtblJobId: null,
      IsEstelamCodeMeli: false,
    };
  },
  components: {
    NetPaCard,
    Panel,
    datePicker: VuePersianDatetimePicker,
    loading,
    Dropdown,
    ModalCustom,
    CaptchaBox,
  },
  props: ["Islogin", "RegisterCheck"],
  created() {
    this.$GetAppsettingsAsync()
      .then(() => {
        this.gettblCustomer();
      })
      .catch(() => {
        this.gettblCustomer();
      });
  },
  mounted() {
    if (this.Islogin == undefined) {
      document.documentElement.classList.add("register-page-html");
      document.body.classList.add("register-page-html");
    }
    this.randomKey = "";

    if (this.Islogin == true && this.Islogin != undefined) {
      this.rdoAsli = false;
      this.IsVabaste = true;
      this.CodeMeliVabaste = this.$session.get("UserInfoNetPa").codeMeli.trim();
      this.Moshakhasat =
        JSON.parse(JSON.stringify(this.$session.get("UserInfoNetPa"))).ozvName +
        " " +
        JSON.parse(JSON.stringify(this.$session.get("UserInfoNetPa")))
          .ozvFamily;
      this.wwwtblAzaIdSahebHesab = this.$session.get("UserInfoNetPa").id;
      var formdata2 = new FormData();
      formdata2.append("custcode", this.$session.get("CustCode"));
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata2,
        Method: "Post",
        Action: "TafsiliType/GetAll",
        Token: "",
      };

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          // console.log(res);
          this.ListModelTafsily = res;
          var a = res.filter(
            (i) =>
              i.id == this.$session.get("UserInfoNetPa").wwwtblTafsiliTypeId,
          );
          this.nameTafsiliType = a[0].nameTafsiliType;
          this.ResultcmbcmbTafsiliType = a;
          this.loadingRender = false;
          this.bnpCashDbtblTafsiliTypeId = a[0].bnpCashDbtblTafsiliTypeId;
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: "",
            Action: "TafsiliType/GetTblBank",
            method: "post",
            Token: "",
          })
            .then((res) => {
              this.ListModelBank = res;
              this.ResultcmbBank = res[0].bnpCashDbtblBankId;
            })
            .finally(() => {
              this.loadingRender = true;
              var formdata = new FormData();
              formdata.append("BnpId", this.bnpCashDbtblTafsiliTypeId);
              formdata.append("custcode", this.$session.get("CustCode"));
              var DataAxios_TafsiliType = {
                ArryfildValue: formdata,
                Method: "Post",
                Action: "AzaNoe/GetIndex",
                Token: "",
              };
              this.$PostFormData(DataAxios_TafsiliType)
                .then((data) => {
                  var b = data.filter(
                    (x) =>
                      x.id == this.$session.get("UserInfoNetPa").wwwtblAzaNoeId,
                  );
                  this.nameAzanoe = b[0].nameHoze;
                  this.ResultcmbcmbAzaNoeArray = b;
                })
                .finally(() => {
                  this.loadingRender = false;
                });
            });
        });
    } else if (this.RegisterCheck != 0 && this.RegisterCheck != undefined) {
      this.state = 2;
      this.gettblCustomer();
      this.GetAzaAndAttach(this.RegisterCheck);
      //this.stage=3
    } else {
      this.gettblCustomer();
    }
  },
  updated() {},
  methods: {
    async getApiBaseReady() {
      let base = this.$GetapiBase();
      if (!base) {
        await this.$GetAppsettings();
        base = this.$GetapiBase();
      }
      return base || "";
    },
    async gettblCustomer() {
      const apiBase = await this.getApiBaseReady();
      this.IsEstelamCodeMeli =
        this.$GetIsEstelamCodeMeli() == ""
          ? sessionStorage.getItem("IsEstelamCodeMeli")
          : this.$GetIsEstelamCodeMeli();
      this.loadingRender = true;
      var settings = {
        method: "Post",
        url: apiBase + "Setting",
        headers: {},
        data: null,
      };
      var axios = require("axios");
      //   console.log('settings',settings);
      axios(settings).then((result) => {
        this.$PostData({
          ArryfildValue: {},
          Action: "GetTblCustomer",
          method: "GET",
          Token: "",
        })
          .then((data) => {
            // console.log('dataaa',data);
            this.$store.state.NameSandogh = data.name;
            this.$session.set("NameSandogh", data.name);
            this.$session.set("CustCode", data.custCode);
            document.title = " خدمات الکترونیکی " + data.name;
            this.txtTafsilytype =
              this.$session.get("CustCode") == "932"
                ? "وضعیت اشتغال "
                : "نوع عضویت";
            this.filCombo();
            this.loadingRender = false;
          })
          .catch(function (error) {
            //console.log(error)
          });
      });
    },
    onCaptchaValid({ valid, captchaId, userInput }) {
      this.CaptchaValid = valid;
      this.captchaId = captchaId;
      this.captchaText = userInput;
    },
    onCaptchaValid2({ valid, captchaId, userInput }) {
      this.CaptchaValid2 = valid;
      this.captchaId2 = captchaId;
      this.captchaText2 = userInput;
    },
    onCaptchaValid3({ valid, captchaId, userInput }) {
      this.CaptchaValid3 = valid;
      this.captchaId3 = captchaId;
      this.captchaText3 = userInput;
    },
    refreshCaptcha() {
      this.$refs.captchaRef.generateCaptcha();
      this.$refs.captchaRef2.generateCaptcha();
    },
    Check() {
      this.$router.push("/RegisterCheck/0");
    },
    filCombo() {
      var formdata = new FormData();
      formdata.append("custcode", this.$session.get("CustCode"));
      var DataAxios_TafsiliType2 = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "TafsiliType/GetAll",
        Token: this.$session.get("TokenNetPa"),
      };

      this.$PostFormData(DataAxios_TafsiliType2)
        .then((res) => {
          this.OptionsvalidateSelection2 = [];
          // console.log(res);
          this.ListModelTafsily = res;
          for (let index = 0; index < this.ListModelTafsily.length; index++) {
            const element = this.ListModelTafsily[index];

            if (element.id != 3527160) {
              var option = {
                name: element.nameTafsiliType,
                id: element,
              };
              /*if (this.$session.get("CustCode") == "948") {
                // k.hr if (element.bnpCashDbtblTafsiliTypeId === 291) {
                //   this.OptionsvalidateSelection2.push(option);
                // }
                if (
                  element.bnpCashDbtblTafsiliTypeId !== 30818 &&
                  element.bnpCashDbtblTafsiliTypeId !== 26513
                ) {
                  this.OptionsvalidateSelection2.push(option);
                }
              } else */
              if (this.$session.get("CustCode") == "860") {
                //اطلاعات نوع عضویت عام برای مشتریانی که فقط عضویت عام میخواهند
                if (element.bnpCashDbtblTafsiliTypeId == 100423) {
                  this.OptionsvalidateSelection2.push(option);
                }
              } else {
                this.OptionsvalidateSelection2.push(option);
              }
            }
          }

          this.loadingRender = false;
        })
        .finally(() => {
          this.$PostFormData({
            ArryfildValue: "",
            Action: "TafsiliType/GetTblBank",
            method: "post",
            Token: "",
          })
            .then((res) => {
              this.ListModelBank = res;
              this.ResultcmbBank = res[0].id;
            })
            .finally(() => {
              if (this.$session.get("CustCode") == "932") {
                this.GetcmbGrp325();
              }
            });
        });
    },
    GetAzaAndAttach(id) {
      // alert()
      var formdata = new FormData();
      formdata.append("Id", id);
      var DataAxios_GetAza = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "NewtblAza/GetWwwNewtblAzaById",
        Token: "",
      };
      this.$PostFormData(DataAxios_GetAza)
        .then((res) => {
          //console.log(res);
          if (res != null) {
            this.stage = 3;
            this.FixInput = true;
            this.OzvName = res.ozvName;
            this.OzvFamily = res.ozvFamily;
            this.CodeMeli = res.codeMeli;
            this.BirthDate = res.birthDate;
            this.cmbSEX = res.tblComboIdSex13;
            this.Mobile = res.mobile;
            this.Pedar = res.pedar;
            this.Address = res.adres;
            this.Tel = res.tel;
            this.Shenasname = res.shenasname;
            this.PerNo = res.perNo;
            this.cmbTaahol = res.tblComboIdTahol19;
            this.HesabNo = Number(res.hesabNo.trim());
            this.ResultcmbBank = res.wwwtblBankId;
            this.ResultcmbcmbTafsiliType = res.wwwtblTafsiliTypeId;
            this.ResultcmbcmbAzaNoeArray = res.wwwtblAzaNoeId;
            this.GetDataRegister();
          } else {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطایی رخ داد است",
              "error",
              2000,
            );
            this.loadingRender = false;
          }
        })
        .finally(() => {
          var formdata2 = new FormData();
          formdata2.append("MasterId", id);
          var DataAxios_GetAzaAttach = {
            ArryfildValue: formdata2,
            Method: "Post",
            Action: "NewtblAza/GetAttachment",
            Token: "",
          };
          this.$PostFormData(DataAxios_GetAzaAttach).then((res) => {
            // console.log(res);

            if (res != null) {
              this.setFile(res);
            }
          });
        });
    },
    // GetAzaNoe(){
    //     if(this.ResultcmbcmbAzaNoeArray!=undefined){
    //     if(this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId>0 ){
    //         var formdata = new FormData()
    //         formdata.append("BnpId" , this.ResultcmbcmbAzaNoeArray.bnpCashDBtblTafsiliTypeId)
    //         var DataAxios_TafsiliType = { ArryfildValue: formdata,Method: "Post",Action: "TafsiliType",Token: ''}
    //         this.$PostFormData(DataAxios_TafsiliType).then(data =>{
    //             this.ListModelTafsiliType=null
    //             this.ListModelTafsiliType=data
    //             this.ResultcmbcmbTafsiliType=data[0].id
    //         })

    //     }
    //     else{
    //         this.$mySweetDefaultTost('عملیات ناموفق', ' مشکل در بارگذاری شعبه مذکور', 'error', 4000)
    //         this.ResultcmbcmbTafsiliType=null
    //                     return;
    //     }
    //     }
    // },
    async zip() {
      let zip = new JSZip();
      zip.file(this.fileinfo1.name, this.fileinfo1);
      zip.file(this.fileinfo2.name, this.fileinfo2);
      if (this.fileinfo3 && this.fileinfo3.name) {
        zip.file(this.fileinfo3.name, this.fileinfo3);
      }

      const convertBase64 = await zip.generateAsync({ type: "base64" });
      const base64 = ("data:application/zip;base64," + convertBase64).split(
        ",",
      )[1];
      this.FileZip = base64;

      const ok1 = await this.uploadSingleDoc(
        document.getElementById("Uploader1").files[0],
        181070514,
      );
      const ok2 = await this.uploadSingleDoc(
        document.getElementById("Uploader2").files[0],
        181070505,
      );
      let ok3 = true;
      if (this.fileinfo3 && this.fileinfo3.name) {
        ok3 = await this.uploadSingleDoc(
          document.getElementById("Uploader3").files[0],
          181070516,
        );
      }

      if (!ok1 || !ok2 || !ok3) {
        return "";
      }

      return base64;
    },

    async uploadSingleDoc(file, grp328) {
      const formdata = new FormData();
      formdata.append("IdEftetah", this.IdEftetah);
      formdata.append("Image", file);
      formdata.append("TableName", " ");
      formdata.append("wwwtblcomboidgrp328", grp328);
      this.DataAxiosUpload.ArryfildValue = formdata;
      this.DataAxiosUpload.Action = "EftetahHesab/SaveAttachmentToDb";
      try {
        const data = await this.$PostFormData(this.DataAxiosUpload);
        if (data.status != "Ok") {
          // this.$mySweetDefaultTost(
          //   "عملیات ناموفق",
          //   " مشکلی در بارگذاری مدارک بوجود آمده است. دوباره تلاش کنید",
          //   "error",
          //   4000,
          // );
          return false;
        }
        return true;
      } catch (err) {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          " مشکلی در بارگذاری مدارک بوجود آمده است. دوباره تلاش کنید",
          "error",
          4000,
        );
        return false;
      }
    },
    async SaveImages() {
      var formdata3 = new FormData();
      formdata3.append("IdEftetah", this.IdEftetah);
      formdata3.append("Image", document.getElementById("Uploader1").files[0]);
      this.DataAxiosUpload.ArryfildValue = formdata3;
      this.$PostFormData(this.DataAxiosUpload).then((data) => {
        if (data.status == "Ok") {
          var formdata1 = new FormData();
          formdata1.append("IdEftetah", this.IdEftetah);
          formdata1.append(
            "Image",
            document.getElementById("Uploader2").files[0],
          );
          this.DataAxiosUpload.ArryfildValue = formdata1;
          this.$PostFormData(this.DataAxiosUpload).then((data) => {
            if (data.status == "Ok") {
              var formdata2 = new FormData();
              formdata2.append("IdEftetah", this.IdEftetah);
              formdata2.append(
                "Image",
                document.getElementById("Uploader3").files[0],
              );
              this.DataAxiosUpload.ArryfildValue = formdata2;
              this.$PostFormData(this.DataAxiosUpload).then((data) => {
                if (data.status == "Ok") {
                }
              });
            }
          });
        }
      });
    },
    isBase64(str) {
      try {
        return btoa(atob(str)) == str;
      } catch (err) {
        return false;
      }
    },
    sendSms() {
      if (this.$ValidForm("div1")) {
        if (this.CodeMeli == "") {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " کد ملی نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }
        if (this.Mobile == "") {
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه نمیتواند خالی باشد.",
            "error",
            2000,
          );
          return;
        }

        if (this.Mobile.length != 11) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  شماره همراه 11 رقمی است.",
            "error",
            2000,
          );
          return;
        }
        if (this.CodeMeli.length != 10) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            "  کد ملی  10 رقمی است.",
            "error",
            2000,
          );
          return;
        }
        if (!this.CaptchaValid) {
          this.refreshCaptcha();
          this.$mySweetDefaultTost(
            "خطا",
            " متن تصویر به درستی وارد نشده است",
            "error",
            2000,
          );
          return;
        } else {
          this.loadingRender = true;
          if (this.IsEstelamCodeMeli == "true") {
            let Model = {
              CodeMeli: this.CodeMeli,
              Mobile: this.Mobile,
              BirthDate: this.BirthDate,
              CustCode: this.$session.get("CustCode"),
            };
            this.$PostData_new("GetInfocodeMeli", "POST", Model).then((re) => {
              if (re.result == "false") {
                this.MsgEstelamCodeMeli = re.msg;
                this.$mySweetDefaultTost("خطا", re.msg, "error", 3800);
                this.loadingRender = false;
              }
              if (re.result == "faild") {
                this.MsgEstelamCodeMeli = re.msg;
                this.$mySweetDefaultTost(
                  "عدم احراز هویت",
                  re.msg,
                  "warning",
                  4500,
                );
                this.loadingRender = false;
              }
              if (re.result == "success" && re.type == "2") {
                var DataAxiosRegisterAuth = {
                  ArryfildValue: {},
                  Action: "EftetahHesab/RegisterAuth",
                  Method: "POST",
                  Token: "",
                };
                const formData = new FormData();
                formData.append("mobile", this.Mobile);
                formData.append("codeMeli", this.CodeMeli);
                formData.append("userInput", this.captchaText);
                formData.append("captchaId", this.captchaId);
                formData.append("IsSendSms", false);
                DataAxiosRegisterAuth.ArryfildValue = formData;
                this.$PostFormData(DataAxiosRegisterAuth).then((data) => {});
                this.ResultEstelamCodeMeli = re.data;
                this.stage = 2;
                this.$mySweetDefaultTost(
                  "ارسال موفق",
                  "کد احراز هویت برای شما پیامک شد ، دریافت کد به علت ترافیک پیامک ها ممکن است کمی زمان بر باشد",
                  "success",
                  4500,
                );
                this.loadingRender = false;
              }
              if (re.result == "success" && re.type == "1") {
                var DataAxiosRegisterAuth = {
                  ArryfildValue: {},
                  Action: "EftetahHesab/RegisterAuth",
                  Method: "POST",
                  Token: "",
                };
                const formData = new FormData();
                formData.append("mobile", this.Mobile);
                formData.append("codeMeli", this.CodeMeli);
                formData.append("userInput", this.captchaText);
                formData.append("captchaId", this.captchaId);
                formData.append("IsSendSms", false);
                DataAxiosRegisterAuth.ArryfildValue = formData;
                this.$PostFormData(DataAxiosRegisterAuth).then((data) => {});
                this.EstelamCodeMeli = re.data;
                this.FixInput = true;
                this.OzvName = re.data.name;
                this.OzvFamily = re.data.family;
                this.CodeMeli = re.data.idCode;
                this.BirthDate = re.data.birthDate;
                this.cmbSEX = re.data.gender === "مرد" ? 4041 : 4042;
                this.Mobile = re.data.mobile;
                this.Pedar = re.data.fatherName;
                this.Shenasname = re.data.shomareShenasname;
                this.stage = 3;
                this.GetDataRegister();
              }
              this.loadingRender = false;
            });
          } else {
            var DataAxiosRegisterAuth = {
              ArryfildValue: {},
              Action: "EftetahHesab/RegisterAuth",
              Method: "POST",
              Token: "",
            };
            const formData = new FormData();
            formData.append("mobile", this.Mobile);
            formData.append("codeMeli", this.CodeMeli);
            formData.append("userInput", this.captchaText);
            formData.append("captchaId", this.captchaId);
            formData.append("IsSendSms", true);
            DataAxiosRegisterAuth.ArryfildValue = formData;
            this.$PostFormData(DataAxiosRegisterAuth)
              .then((data) => {
                this.$mySweetDefaultTost(" ", data.msg, data.icone, 3000);
                if (data.status == "Ok") {
                  this.stage = 2;
                  this.loadingRender = false;
                } else {
                  this.stage = 1;
                  this.loadingRender = false;
                }
              })
              .finally(() => {
                document.getElementById("txtRandoKey").focus();
              });
          }
        }
      }
    },
    OkCode() {
      this.loadingRender = true;
      if (this.IsEstelamCodeMeli == "true") {
        var est = this.ResultEstelamCodeMeli || {};
        var estRes = est.result || est.Result || {};
        let Model = {
          ResultId: estRes.id || estRes.ID || "",
          ComfirmMobile: this.randomKey,
          CodeMeli: this.CodeMeli,
          Mobile: this.Mobile,
        };
        this.$PostData_new("GetInfocodeMeliByOTP", "POST", Model).then((re) => {
          this.loadingRender = false;
          if (re == null || re.result == "false" || re.result == "faild") {
            this.MsgEstelamCodeMeli = re && re.msg ? re.msg : "خطا در بررسی کد احراز هویت";
            this.$mySweetDefaultTost("خطا", this.MsgEstelamCodeMeli, "error", 4800);
            this.stage = 2;
            return;
          }
          var person = re.result || {};
          var nid = (person.id || person.idCode || "").toString().trim();
          if (!nid) {
            this.MsgEstelamCodeMeli = re.msg || "خطا در بررسی کد احراز هویت";
            this.$mySweetDefaultTost("خطا", this.MsgEstelamCodeMeli, "error", 4800);
            this.stage = 2;
            return;
          }
          this.$mySweetDefaultTost(
            "احراز موفق",
            "کاربر گرامی : " +
              (person.name || "") +
              " " +
              (person.family || "") +
              "احراز هویت شما با موفقیت انجام گردید",
            "success",
            4800,
          );
          this.stage = 3;
          this.EstelamCodeMeli = re;
          this.FixInput = true;
          this.OzvName = person.name;
          this.OzvFamily = person.family;
          this.CodeMeli = person.idCode || person.id;
          this.BirthDate = person.birthDate;
          this.cmbSEX = person.gender === "مرد" ? 4041 : 4042;
          this.Mobile = person.mobile;
          this.Pedar = person.fatherName;
          this.Shenasname = person.nationalId;
          this.GetDataRegister();
        });
      } else {
        var DataAxiosDataAxiosRegisterAuth = {
          ArryfildValue: {},
          Action: "EftetahHesab/RegisterOK",
          Method: "POST",
          Token: "",
        };
        const formData = new FormData();

        formData.append("codeMeli", this.CodeMeli);
        formData.append("randomKey", this.randomKey);
        formData.append("userInput", this.captchaText3);
        formData.append("captchaId", this.captchaId3);
        DataAxiosDataAxiosRegisterAuth.ArryfildValue = formData;
        this.$PostFormData(DataAxiosDataAxiosRegisterAuth).then((data) => {
          this.$mySweetDefaultTost(" ", data.msg, data.icone, 4000);
          if (data.status == "Ok") {
            this.stage = 3;
            this.GetDataRegister();
            this.loadingRender = false;
          } else {
            this.loadingRender = false;
            this.stage = 2;
          }
        });
      }
    },
    async SabtOzv() {
      // console.log(this.ResultcmbcmbTafsiliType);

      if (this.$requiredCodeMeli("Register")) {
        if (this.$ValidForm("Register")) {
          if (this.IsVabaste) {
            if (this.CodeMeliVabaste == "") {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " لطفا کد ملی فرد اصلی را وارد نمایید ",
                "error",
                4000,
              );
              return;
            }
            if (this.CodeMeliVabaste == this.CodeMeli) {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " کد ملی وارد شده با کد ملی فرد وابسته نمیتواند یکسان باشد ",
                "error",
                4000,
              );
              return;
            }
            if (this.wwwtblAzaIdSahebHesab == 0) {
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " کد ملی وارد شده برای فرد اصلی معتبر نمیباشد",
                "error",
                4000,
              );
              return;
            }
          }
          if (this.Tel.length != 11 && this.$session.get("CustCode") == "948") {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا تلفن تماس را با کد شهر و به صورت یازده رقمی وارد کنید",
              "error",
              4000,
            );
            return;
          }
          if (
            this.CodePosti.length != 10 &&
            this.$session.get("CustCode") == "948"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا کد پستی را با فرمت صحیح و به صورت ده رقمی وارد کنید",
              "error",
              4000,
            );
            return;
          }

          if (
            (this.ResultcmbcmbTafsiliType == null ||
              this.ResultcmbcmbAzaNoeArray == undefined) &&
            this.$session.get("CustCode") == "801"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              " اتخاب محل کار و شعبه افتتاح کننده حساب اجباری است",
              "error",
              4000,
            );
            return;
          }
          if (
            (this.wwwtblJobId == null ||
              this.wwwtblJobId == undefined ||
              this.wwwtblJobId == 0) &&
            this.$session.get("CustCode") == "932"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              " اتخاب نوع اداره کل بیمه یا درمان اجباری است",
              "error",
              4000,
            );
            return;
          }
          if (
            (this.ResultcmbcmbTafsiliType == null ||
              this.ResultcmbcmbTafsiliType == undefined ||
              this.ResultcmbcmbTafsiliType == 0) &&
            this.$session.get("CustCode") != "953"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا نوع عضویت را از بخش سایر اطلاعات انتخاب نمایید",
              "error",
              2000,
            );
            return;
          }
          if (
            (this.ResultcmbcmbAzaNoeArray == null ||
              this.ResultcmbcmbAzaNoeArray == undefined ||
              this.ResultcmbcmbAzaNoeArray == 0) &&
            this.$session.get("CustCode") != "953"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا دسته بندی را از بخش سایر اطلاعات انتخاب نمایید",
              "error",
              2000,
            );
            return;
          }
          if (!this.CaptchaValid2) {
            this.refreshCaptcha();
            this.$mySweetDefaultTost(
              "خطا",
              " متن تصویر به درستی وارد نشده است",
              "error",
              2000,
            );
            return;
          }
          this.loadingRender = true;
          this.DataAxios.ArryfildValue = {
            OzvName: this.OzvName,
            OzvFamily: this.OzvFamily,
            Pedar: this.Pedar,
            Shenasname: this.Shenasname,
            Email: "",
            MahalSodor: this.Sodor,
            CodeMeli: this.CodeMeli,
            Adres: this.Address,
            Tel: this.Tel,
            Mobile: this.Mobile,
            tblComboIdSex13: this.cmbSEX,
            tblComboIdTahol19: this.cmbTaahol,

            wwwtblTafsiliTypeId:
              this.Islogin == undefined
                ? this.$session.get("CustCode") != "953"
                  ? this.ResultcmbcmbTafsiliType.id
                  : 0
                : this.ResultcmbcmbTafsiliType[0].id,
            wwwtblAzaNoeId:
              this.Islogin == undefined
                ? this.$session.get("CustCode") != "953"
                  ? this.ResultcmbcmbAzaNoeArray.id
                  : 0
                : this.ResultcmbcmbAzaNoeArray[0].id,
            PerNo: this.PerNo,
            HesabNo: this.HesabNo + "",
            tblBankId: this.ResultcmbBank,
            wwwtblAzaIdSahebHesab:
              this.$session.get("CustCode") == "948"
                ? 0
                : this.wwwtblAzaIdSahebHesab != null
                ? this.wwwtblAzaIdSahebHesab
                : 0,
            BirthDate: this.BirthDate,
            desMoaref: this.moaref,
            wwwtblJobsId: this.wwwtblJobId,
            userInput: this.captchaText2,
            captchaId: this.captchaId2,
            CodePosti: this.CodePosti,
            BnpCashDBtblTafsiliTypeId:
              this.ResultcmbcmbTafsiliType.bnpCashDbtblTafsiliTypeId,
            BnpCashDBtblAzaNoeId:
              this.ResultcmbcmbAzaNoeArray.bnpCashDbtblAzaNoeId,
          };

          if (this.$session.get("CustCode") == "860" && !this.fileinfo.name) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }

          if (
            this.$session.get("CustCode") == "932" &&
            (!this.fileinfo1.name ||
              !this.fileinfo2.name ||
              !this.fileinfo3.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا هر سه فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "953" &&
            (!this.fileinfo1.name || !this.fileinfo2.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل های تصاویر شناسنامه و کارت ملی خودرا بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "932" &&
            this.AcceptGhavnin932 == false
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عدم پذیرش شرایط و ضوابط",
              " لطفا درصورت پذیرش شرایط و ضوابط تیک پذیرش را بزنید و سپس نسبت به ثبت اطلاعات اقدام فرمایید . ",
              "error",
              4000,
            );
            return;
          }
          try {
            const data = await this.$PostData(this.DataAxios);

            if (data.status == "NoSUCCESS_2") {
              this.loadingRender = false;
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " درخواست عضویت شما قبلا ثبت شده است لطفا نتیجه را از شعبه استعلام نمایید ",
                "error",
                4000,
              );
              return;
            }
            if (data.status == "NoSUCCESS_1") {
              this.loadingRender = false;
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " شما در حال حاضر عضو میباشید و امکان درخواست عضویت وجود ندارد",
                "error",
                4000,
              );
              return;
            }
            if (data.status == "NotOk") {
              this.loadingRender = false;
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                data.msg,
                data.icone,
                4000,
              );
              return;
            }

            // member row is now saved
            this.IdEftetah = data.id;

            let uploadOk = true; // stays true when this customer needs no upload at all

            if (
              this.$session.get("CustCode") != "932" &&
              this.$session.get("CustCode") != "953" &&
              this.$session.get("CustCode") != "948" &&
              this.fileinfo.name
            ) {
              const formdata = new FormData();
              formdata.append("IdEftetah", this.IdEftetah);
              formdata.append(
                "Image",
                document.getElementById("Uploader").files[0],
              );
              this.DataAxiosUpload.ArryfildValue = formdata;
              try {
                const upData = await this.$PostFormData(this.DataAxiosUpload);
                uploadOk = upData.status == "Ok";
              } catch (e) {
                uploadOk = false;
              }
            } else if (
              (this.$session.get("CustCode") == "932" ||
                this.$session.get("CustCode") == "953") &&
              (this.fileinfo1.name ||
                this.fileinfo2.name ||
                this.fileinfo3.name)
            ) {
              const zipFile = await this.zip();
              if (zipFile) {
                const formdata = new FormData();
                formdata.append("Image", JSON.stringify(zipFile));
                formdata.append("IdEftetah", this.IdEftetah);
                this.DataAxiosUpload.ArryfildValue = formdata;
                this.DataAxiosUpload.Action = "EftetahHesab/UploadAtachment";
                try {
                  const upData = await this.$PostFormData(this.DataAxiosUpload);
                  uploadOk = upData.status == "Ok";
                } catch (e) {
                  uploadOk = false;
                }
              } else {
                uploadOk = false; // one of the individual uploads inside zip() already failed
              }
            }

            this.loadingRender = false;

            if (!uploadOk) {
              try {
                const formdata = new FormData();
                formdata.append("codemeli", this.CodeMeli);
                const deleteSavedInfo = await this.$PostFormData({
                  ArryfildValue: formdata,
                  Method: "Post",
                  Action: "EftetahHesab/DeleteSavedAzaIfFileIsNotSaved",
                  Token: "",
                });
                if (deleteSavedInfo.status == "Ok") {
                  this.$mySweetDefaultTost(
                    "عملیات ناموفق",
                    "مشکلی در بارگذاری مدارک پیش آمد و ثبت‌نام شما انجام نشد. لطفا دوباره تلاش کنید.",
                    "error",
                    5000,
                  );
                  return;
                } else {
                  this.$mySweetDefaultTost(
                    "عملیات ناموفق",
                    "ثبت‌نام شما ناقص انجام شد، مشکلی در بارگذاری مدارک پیش آمد.",
                    "error",
                    5000,
                  );
                  return;
                }
              } catch (e) {
                this.$mySweetDefaultTost(
                  "عملیات ناموفق",
                  "ثبت‌نام شما ناقص انجام شد، مشکلی در بارگذاری مدارک پیش آمد.",
                  "error",
                  5000,
                );
                return;
              }
            } else {
              this.$mySweetDefaultTost(
                "عملیات موفق",
                "درخواست شما با موفقیت ثبت شد.",
                "success",
                5000,
              );

              if (
                this.$session.get("CustCode") == "932" ||
                this.$session.get("CustCode") == "953"
              ) {
                this.$router.push({
                  name: "RegisterCheck",
                  params: { Status: this.IdEftetah },
                });
                return;
              }
            }

            this.SendSmsRegister(this.IdEftetah);
            this.$router.push({ name: "LoginPage" });
            return;
          } catch (err) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطا در ارتباط با سرور، لطفا دوباره تلاش کنید",
              "error",
              4000,
            );
          }
        }
      } else {
        this.$mySweetDefaultTost(
          "عملیات ناموفق",
          " فرمت کد ملی نامعتبر میباشد ",
          "error",
          3000,
        );
        return;
      }
    },
    SendSmsRegister(coderahgiri) {
      var formdata = new FormData();

      //formdata.append('mobile', mobile)
      formdata.append("coderahgiri", coderahgiri);
      formdata.append("userInput", this.captchaText2);
      formdata.append("captchaId", this.captchaId2);
      var DataAxios_sendSMS = {
        ArryfildValue: formdata,
        Action: "EftetahHesab/SendSmsRegister",
        Method: "POST",
        Token: "",
      };
      this.$PostFormData(DataAxios_sendSMS).then((data) => {
        // console.log(data)
      });
    },
    async EditOzv() {
      if (this.$requiredCodeMeli("Register")) {
        if (this.$ValidForm("Register")) {
          this.DataAxiosEdit.ArryfildValue = {
            Id: this.RegisterCheck,
            OzvName: this.OzvName,
            OzvFamily: this.OzvFamily,
            Pedar: this.Pedar,
            Shenasname: this.Shenasname,
            Email: "",
            MahalSodor: this.Sodor,
            CodeMeli: this.CodeMeli,
            Adres: this.Address,
            Tel: this.Tel,
            Mobile: this.Mobile,
            tblComboIdSex13: this.cmbSEX,
            tblComboIdTahol19: this.cmbTaahol,
            wwwtblTafsiliTypeId:
              this.Islogin == undefined
                ? this.ResultcmbcmbTafsiliType.id
                : this.ResultcmbcmbTafsiliType[0].id,
            wwwtblAzaNoeId:
              this.Islogin == undefined
                ? this.ResultcmbcmbAzaNoeArray.id
                : this.ResultcmbcmbAzaNoeArray[0].id,
            PerNo: this.PerNo,
            HesabNo: this.HesabNo + "",
            tblBankId: this.ResultcmbBank,
            wwwtblAzaIdSahebHesab:
              this.wwwtblAzaIdSahebHesab != null
                ? this.wwwtblAzaIdSahebHesab
                : 0,
            BirthDate: this.BirthDate,
          };

          if (this.$session.get("CustCode") == "860" && !this.fileinfo.name) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "932" &&
            (!this.fileinfo1.name ||
              !this.fileinfo2.name ||
              !this.fileinfo3.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا هر سه فایل خواسته شده را بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (
            this.$session.get("CustCode") == "953" &&
            (!this.fileinfo1.name || !this.fileinfo2.name)
          ) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "آپلود ناموفق",
              " لطفا فایل تصاویر کارت ملی و شناسنامه خودرا بارگذاری ، سپس دوباره اقدام به درخواست ثبت عضویت خود کنید ",
              "error",
              2000,
            );
            return;
          }
          if (this.Tel.length != 11 && this.$session.get("CustCode") == "948") {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا تلفن تماس را با کد شهر و به صورت یازده رقمی وارد کنید",
              "error",
              4000,
            );
            return;
          }
          if (
            this.CodePosti.length != 10 &&
            this.$session.get("CustCode") == "948"
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "لطفا کد پستی را با فرمت صحیح و به صورت ده رقمی وارد کنید",
              "error",
              4000,
            );
            return;
          }

          try {
            const data = await this.$PostData(this.DataAxiosEdit);

            if (data.status != "true") {
              this.loadingRender = false;
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                " در ویرایش مشخصات شما مشکلی پیش آمده لطفا مجدد تلاش کنید",
                "error",
                4000,
              );
              return;
            }

            let uploadOk = true;

            if (
              this.$session.get("CustCode") == "932" &&
              (this.fileinfo1.name ||
                this.fileinfo2.name ||
                this.fileinfo3.name)
            ) {
              if (this.fileinfo1Isedit)
                uploadOk =
                  uploadOk &&
                  (await this.uploadEditedDoc(this.fileinfo1, 181070514));
              if (this.fileinfo2Isedit)
                uploadOk =
                  uploadOk &&
                  (await this.uploadEditedDoc(this.fileinfo2, 181070505));
              if (this.fileinfo3Isedit)
                uploadOk =
                  uploadOk &&
                  (await this.uploadEditedDoc(this.fileinfo3, 181070516));
            } else if (
              this.$session.get("CustCode") == "953" &&
              (this.fileinfo1.name || this.fileinfo2.name)
            ) {
              if (this.fileinfo1Isedit)
                uploadOk =
                  uploadOk &&
                  (await this.uploadEditedDoc(this.fileinfo1, 181070514));
              if (this.fileinfo2Isedit)
                uploadOk =
                  uploadOk &&
                  (await this.uploadEditedDoc(this.fileinfo2, 181070505));
            }

            this.loadingRender = false;

            if (!uploadOk) {
              // the person's data WAS updated successfully - never delete/revert that.
              // just be honest that the document part failed, and keep them here to retry.
              this.$mySweetDefaultTost(
                "عملیات ناموفق",
                "اطلاعات شما ویرایش شد اما مشکلی در بارگذاری مدارک پیش آمد. لطفا دوباره تلاش کنید.",
                "error",
                5000,
              );
              return;
            }

            this.$mySweetDefaultTost(
              "عملیات موفق",
              "درخواست شما با موفقیت ویرایش شد.",
              "success",
              3000,
            );
            this.$router.push({ name: "LoginPage" });
          } catch (err) {
            this.loadingRender = false;
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "خطا در ارتباط با سرور، لطفا دوباره تلاش کنید",
              "error",
              4000,
            );
          }
        }
      }
    },

    async uploadEditedDoc(file, grp328) {
      const formdata = new FormData();
      formdata.append("Image", file);
      formdata.append("IdEftetah", this.RegisterCheck);
      formdata.append("wwwtblcomboidgrp328", grp328);
      this.DataAxiosUpload.ArryfildValue = formdata;
      this.DataAxiosUpload.Action = "EftetahHesab/EditUploadAtachment";
      try {
        const data = await this.$PostFormData(this.DataAxiosUpload);
        return data.status == "Ok"; // confirm this matches what EditUploadAtachment actually returns
      } catch (e) {
        return false;
      }
    },
    changeRdo() {
      if (this.rdoAsli) {
        this.rdoAsli = false;
        this.IsVabaste = true;
      } else {
        if (!this.rdoAsli) {
          this.rdoAsli = true;
          this.IsVabaste = false;

          this.CodeMeliVabaste = "";
          this.Moshakhasat = "";
        }
      }
    },
    CheckCodemeli() {
      var formdata = new FormData();
      formdata.append("Codemeli", this.CodeMeliVabaste);
      var DataAxiosGetuser = {
        ArryfildValue: formdata,
        Method: "Post",
        Action: "getCodeMeli",
        Token: "",
      };
      this.$PostFormData(DataAxiosGetuser).then((data) => {
        if (data.status == "OK") {
          this.Moshakhasat = data.data;
          this.wwwtblAzaIdSahebHesab = data.id;
          this.$mySweetDefaultTost(
            "عملیات موفق",
            "  کد ملی معتبر می‌باشد ",
            "success",
            1000,
          );
        } else {
          this.wwwtblAzaIdSahebHesab = 0;
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "  کد ملی نامعتبر می‌باشد ",
            "error",
            3000,
          );
        }
      });
    },
    clickUploader(fileIndex) {
      document.getElementById("Uploader" + fileIndex).click();
    },
    setFile(data) {
      // console.log(data[0]);
      for (let index = 0; index < data.length; index++) {
        const fileInput = null;
        if (index == 0) {
          fileInput = document.getElementById("Uploader1");
        }
        if (index == 1) {
          fileInput = document.getElementById("Uploader2");
        }
        if (index == 2) {
          fileInput = document.getElementById("Uploader3");
        }
        // console.log(fileInput);
        const content = data[index].binary;
        const blob = new Blob([content], { type: "image/png" });
        const fileAdd = new File([blob], data[index].filename);
        const fileList = new DataTransfer();
        fileList.items.add(fileAdd);
        fileInput.files = fileList.files;

        if (index == 0) {
          // console.log(fileList.files[0]);
          this.fileinfo1 = fileList.files[0];
        }
        if (index == 1) {
          // console.log(fileList.files[0]);
          this.fileinfo2 = fileList.files[0];
        }
        if (index == 2) {
          // console.log(fileList.files[0]);
          this.fileinfo3 = fileList.files[0];
        }
      }
    },
    changefile(fileIndex, e) {
      const file = e.target.files[0];
      if (!file) return;

      const allowedExtensions = [
        "gif",
        "jpg",
        "jpeg",
        "png",
        "zip",
        "rar",
        "pdf",
      ];

      const fileExtension = file.name.split(".").pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        this.$mySweetDefaultTost(
          "فرمت فایل مجاز نیست",
          `فرمت ${fileExtension} پشتیبانی نمی‌شود.`,
          "error",
          3000,
        );
        e.target.value = "";
        return;
      }

      // fileIndex is Customer 932 (Bime Tamin Ejtemai)
      if (fileIndex && fileIndex > 0) {
        if (fileIndex == 1) {
          if (
            document.getElementById("Uploader1").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل تصویر کارت ملی بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            // console.log(document.getElementById('Uploader1').files[0]);
            this.fileinfo1 = document.getElementById("Uploader1").files[0];
            this.fileinfo1Isedit = true;
          }
        }
        if (fileIndex == 2) {
          if (
            document.getElementById("Uploader2").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل تصویر صفحه اول شناسنامه بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            this.fileinfo2 = document.getElementById("Uploader2").files[0];
            this.fileinfo2Isedit = true;
          }
        }
        if (fileIndex == 3) {
          if (
            document.getElementById("Uploader3").files[0].size >
            1024 * 1024 * 5
          ) {
            this.$mySweetDefaultTost(
              "عملیات ناموفق",
              "  حجم فایل حکم کارگزینی/مستمری/بازماندگی بیشتر از 5 مگابایت است ",
              "error",
              3000,
            );
            return;
          } else {
            this.fileinfo3 = document.getElementById("Uploader3").files[0];
            this.fileinfo3Isedit = true;
          }
        }
      } else {
        if (
          document.getElementById("Uploader").files[0].size >
          1024 * 1024 * 5
        ) {
          this.$mySweetDefaultTost(
            "عملیات ناموفق",
            "  حجم فایل مورد نظر بیشتر از 5 مگابایت است ",
            "error",
            3000,
          );
          return;
        } else {
          this.fileinfo = document.getElementById("Uploader").files[0];
        }
      }
    },
    validateSelection(data) {
      this.ResultcmbcmbAzaNoeArray = data.id;
    },
    validateSelectionShobe(data) {
      this.ResultcmbcmbTafsiliType = data.id;
      if (this.$session.get("CustCode") != "932") this.GetTafsiliType();
    },
    validateSelectionOstan(data) {
      this.ResultcmbGrp325 = data.id;
      this.GetTafsiliType();
    },
    validateSelectionJob(data) {
      if (data.id != undefined) {
        this.wwwtblJobId = data.id;
      }
    },
    GetcmbGrp325() {
      var dataAxsiosCmb = {
        ArryfildValue: "",
        Method: "post",
        Action: "VaziatCombo",
        Token: this.$session.get("TokenNetPa"),
      };
      const formData = new FormData();
      formData.append("num", 325);
      dataAxsiosCmb.ArryfildValue = formData;
      this.$PostFormData(dataAxsiosCmb).then((datacmb) => {
        datacmb.forEach((element) => {
          let option = {
            name: element.name,
            id: element.id,
          };
          this.OptionsvalidateSelection3.push(option);
        });

        // console.log(datacmb);
      });
    },
    GetTafsiliType() {
      if (
        this.ResultcmbcmbTafsiliType != null &&
        this.ResultcmbcmbTafsiliType != undefined
      ) {
        this.loadingRender = true;
        var formdata = new FormData();
        formdata.append(
          "BnpId",
          this.ResultcmbcmbTafsiliType.bnpCashDbtblTafsiliTypeId,
        );
        formdata.append("custcode", this.$session.get("CustCode"));
        var DataAxios_TafsiliType = {
          ArryfildValue: formdata,
          Method: "Post",
          Action: "AzaNoe/GetIndex",
          Token: "",
        };
        this.$PostFormData(DataAxios_TafsiliType)
          .then((data) => {
            this.ListModelAzaNoe = data;
            this.OptionsvalidateSelection = [];
            for (let index = 0; index < this.ListModelAzaNoe.length; index++) {
              const element = this.ListModelAzaNoe[index];
              if (this.$session.get("CustCode") == "932") {
                if (element.tblComboId325Ostan == this.ResultcmbGrp325) {
                  var option = {
                    name: element.nameHoze,
                    id: element,
                  };
                  this.OptionsvalidateSelection.push(option);
                }
              } else if (this.$session.get("CustCode") == "948") {
                if (
                  element.bnpCashDbtblAzaNoeId == 15 ||
                  element.bnpCashDbtblAzaNoeId == 17 ||
                  element.bnpCashDbtblAzaNoeId == 32036183
                ) {
                  var option = {
                    name: element.nameHoze,
                    id: element,
                  };
                  this.OptionsvalidateSelection.push(option);
                }
              } else {
                var option = {
                  name: element.nameHoze,
                  id: element,
                };
                this.OptionsvalidateSelection.push(option);
              }
            }
          })
          .finally(() => {
            this.loadingRender = false;
          });
      }
    },
    GetDataRegister() {
      this.GetDataJobs();

      this.loadingRender = false;
      // document.getElementsByName('zipcode')[0].classList.add('form-control')
      // document.getElementsByName('zipcode')[0].setAttribute('autocomplete', 'new-password')
      // document.getElementsByName('TafsiliType')[0].classList.add('form-control')
      // document.getElementsByName('TafsiliType')[0].setAttribute('autocomplete', 'new-password')

      this.loadingRender = false;
    },
    GetDataJobs() {
      var dataAxsiosJobs = {
        ArryfildValue: "",
        Method: "post",
        Action: "VaziatCombo/GetJobs",
        Token: this.$session.get("TokenNetPa"),
      };
      this.$PostData(dataAxsiosJobs).then((res) => {
        res.forEach((element) => {
          let option = {
            name: element.jobName,
            id: element.id,
          };
          this.OptionsvalidateSelection4.push(option);
        });
      });
    },
  },
  // computed:{
  //     uploaderDiv(){
  //         if (document.getElementById('Uploader').files.length>0) {
  //             return "FullDiv"
  //         }else
  //         {
  //             return "EmptyDiv"
  //         }
  //     }
  // }
  beforeDestroy() {
    document.documentElement.classList.remove("register-page-html");
    document.body.classList.remove("register-page-html");
  },
  /*mounted() {
    console.log(this.$session.get("CustCode"));
  },*/
};
</script>

<style scoped>
/* Page shell only — scoped so Loading.vue spinner is never affected */
.register-page {
  --bnp-brand-navy: #29345f;
  --bnp-brand-indigo: #56508d;
  --bnp-brand-purple: #8d58a4;
  --bnp-brand-cyan: #05b8c8;
  --bnp-brand-blue: #287db4;
  --bnp-text-primary: #13243a;
  --bnp-text-secondary: #6b7b8e;
  --bnp-surface-subtle: #f9fbfc;
  --bnp-border-default: #dbe5eb;
  --bnp-border-hover: #bdcbd4;
  --bnp-focus-color: #05b8c8;
  --bnp-focus-ring: 0 0 0 4px rgba(5, 184, 200, 0.2);
  --bnp-radius-md: 14px;
  --bnp-shadow-md: 0 12px 24px rgba(41, 52, 95, 0.18);
  --bnp-motion-fast: 180ms;

  position: relative;
  min-height: 100%;
  overflow-x: hidden;
  padding: 12px 16px 28px;
  box-sizing: border-box;
  color: var(--bnp-text-primary);
  background: #f5f7fb !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
}

.register-page--auth {
  min-height: 100vh;
  background: radial-gradient(
      circle at 12% 12%,
      rgba(5, 184, 200, 0.08),
      transparent 28%
    ),
    radial-gradient(
      circle at 88% 88%,
      rgba(141, 88, 164, 0.07),
      transparent 30%
    ),
    #f5f7fb !important;
}

.register-page--auth::before {
  position: fixed;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  content: "";
  opacity: 0.28;
  background-image: linear-gradient(
      rgba(15, 39, 68, 0.025) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(15, 39, 68, 0.025) 1px, transparent 1px);
  background-size: 32px 32px;
  mask-image: linear-gradient(to bottom, black, transparent 80%);
}

.register-glow {
  position: fixed;
  z-index: 0;
  width: 360px;
  height: 360px;
  pointer-events: none;
  border-radius: 50%;
  filter: blur(2px);
}

.register-glow--primary {
  top: -190px;
  right: -130px;
  background: rgba(5, 184, 200, 0.12);
}

.register-glow--secondary {
  bottom: -220px;
  left: -120px;
  background: rgba(141, 88, 164, 0.1);
}
</style>

<style>
html.register-page-html,
body.register-page-html,
body.register-page-html #app,
#RegisterPage.register-page,
#RegisterPage {
  background: #f5f7fb !important;
  background-color: #f5f7fb !important;
  background-image: none !important;
}

#RegisterPage .register-membership-page,
#RegisterPage .register-auth-page {
  position: relative;
  z-index: 1;
  margin-top: 0;
  box-sizing: border-box;
}

#RegisterPage .register-card-shell {
  width: 100%;
  box-sizing: border-box;
}

#RegisterPage .register-card-shell--auth {
  max-width: 560px;
  margin: 8px auto 0;
}

#RegisterPage .register-card-shell--membership {
  margin-top: 8px;
  padding: 0 4px 12px;
}

@media (min-width: 768px) {
  #RegisterPage .register-card-shell--membership {
    padding: 4px 12px 16px;
  }
}

#RegisterPage .register-form-card.netpa-card,
#RegisterPage .register-form-card {
  height: auto !important;
  margin: 0 !important;
  background: #fff !important;
}

#RegisterPage .register-form-card .netpa-card__header {
  background: radial-gradient(
      circle at 100% 0%,
      rgba(5, 184, 200, 0.1),
      transparent 42%
    ),
    radial-gradient(
      circle at 0% 100%,
      rgba(141, 88, 164, 0.08),
      transparent 46%
    ),
    linear-gradient(
      100deg,
      rgba(237, 247, 251, 0.96),
      rgba(255, 255, 255, 0.98) 62%
    ) !important;
}

#RegisterPage .register-form-card .netpa-card__body {
  background: #fff !important;
}

/* Themed auth cards (stage 1 & 2) — specific selectors only, never #RegisterPage * */
#RegisterPage
  .register-auth-page--themed
  .register-form-card
  .netpa-card__body {
  padding: 1.35rem 1.25rem 1.5rem !important;
}

#RegisterPage .register-auth-page--themed .register-auth-panel {
  width: 100%;
  max-width: none;
  margin: 0;
  text-align: right;
}

#RegisterPage .register-auth-page--themed .register-auth-intro h6 {
  margin-bottom: 0.5rem;
  color: #6b7b8e;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.9;
  text-align: right;
}

#RegisterPage .register-auth-page--themed .register-auth-warning {
  margin-top: 0.35rem;
  padding: 10px 12px;
  color: #7c4a45;
  font-size: 12px;
  line-height: 1.8;
  border: 1px solid #f0d4d1;
  border-radius: 12px;
  background: #fcefed;
}

#RegisterPage .register-auth-page--themed .register-auth-form {
  width: 100%;
  max-width: 100%;
  margin-inline: auto;
  padding-inline: 0;
}

#RegisterPage .register-auth-page--themed .register-auth-field {
  margin-bottom: 16px;
  text-align: right;
}

#RegisterPage .register-auth-page--themed .register-auth-label {
  display: block;
  margin-bottom: 8px;
  color: #31465f;
  font-size: 13px;
  font-weight: 700;
  text-align: right;
}

#RegisterPage .register-auth-page--themed .register-auth-input {
  width: 100%;
  height: 52px;
  margin-top: 0 !important;
  padding: 0 16px;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  text-align: center;
  border: 1px solid #dbe5eb;
  border-radius: 14px;
  outline: none;
  background: #f9fbfc;
  box-shadow: none;
  transition: border-color 180ms ease, box-shadow 180ms ease,
    background 180ms ease;
}

#RegisterPage .register-auth-page--themed .register-auth-input::placeholder {
  color: #99a6b4;
}

#RegisterPage .register-auth-page--themed .register-auth-input:hover {
  border-color: #bdcbd4;
}

#RegisterPage .register-auth-page--themed .register-auth-input:focus {
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-auth-page--themed .register-auth-input[type="number"] {
  -moz-appearance: textfield;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-input[type="number"]::-webkit-inner-spin-button,
#RegisterPage
  .register-auth-page--themed
  .register-auth-input[type="number"]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

#RegisterPage .register-auth-page--themed .register-auth-actions {
  margin-top: 4px;
  margin-bottom: 8px;
}

#RegisterPage .register-auth-page--themed .register-auth-submit-btn.btn-submit {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 52px;
  padding: 10px 22px;
  color: #fff !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  border-radius: 14px;
  outline: none;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4) !important;
  box-shadow: 0 12px 24px rgba(41, 52, 95, 0.18);
  transition: transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-submit-btn.btn-submit:not(:disabled):hover {
  color: #fff !important;
  border: 0;
  transform: translateY(-2px);
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4) !important;
  box-shadow: 0 16px 30px rgba(15, 39, 68, 0.24);
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-submit-btn.btn-submit:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2),
    0 12px 24px rgba(41, 52, 95, 0.18);
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-submit-btn.btn-submit:disabled {
  cursor: not-allowed;
  opacity: 0.68;
}

#RegisterPage .register-auth-page--themed .register-auth-secondary-btn {
  min-height: 48px;
  border-radius: 14px;
  font-weight: 700;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-field--captcha
  .input-group {
  margin-bottom: 0 !important;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-field--captcha
  .form-control {
  height: 52px;
  min-height: 52px;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  text-align: center;
  border: 1px solid #dbe5eb;
  border-radius: 14px 0 0 14px;
  background: #f9fbfc;
  box-shadow: none;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-field--captcha
  .form-control:focus {
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-field--captcha
  .input-group-text {
  height: 52px;
  padding: 0 !important;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-right: 0;
  border-radius: 0 14px 14px 0;
  background: #fff;
}

#RegisterPage
  .register-auth-page--themed
  .register-auth-field--captcha
  .input-group-text
  img {
  height: 52px;
  width: auto;
}

#RegisterPage .register-auth-page--themed .vpd-main {
  display: block;
  width: 100%;
}

#RegisterPage .register-auth-page--themed .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 52px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 14px;
  background: #f9fbfc;
  box-shadow: none;
  transition: border-color 180ms ease, box-shadow 180ms ease;
}

#RegisterPage .register-auth-page--themed .vpd-input-group:focus-within {
  border-color: #05b8c8;
  background: #fff;
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-auth-page--themed .vpd-input-group input,
#RegisterPage .register-auth-page--themed .vpd-input-group input.form-control {
  height: 52px;
  min-height: 52px;
  border: 0 !important;
  border-radius: 0;
  background: transparent;
  box-shadow: none !important;
  text-align: center;
}

#RegisterPage .register-auth-page--themed .vpd-input-group .vpd-icon-btn {
  border: 0;
  background: transparent;
  color: #8091a3;
}

#RegisterPage .register-membership-page--solo {
  margin-top: 0;
}

#RegisterPage .register-auth-intro h6 {
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.6;
}

#RegisterPage .register-auth-form {
  width: 100%;
  max-width: 100%;
  margin-inline: auto;
  padding-inline: 0.25rem;
}

#RegisterPage .register-membership-page--themed .netpa-card__header h6 {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0;
  color: #29345f;
  font-size: 15px;
  font-weight: 800;
}

#RegisterPage .register-membership-page--themed .netpa-card__header h6 i {
  color: #56508d;
}

#RegisterPage .register-membership-page--themed .netpa-card__body {
  padding: 1.15rem 1.25rem 1.35rem !important;
  background: #fff !important;
}

#RegisterPage .register-membership-body {
  padding: 0.15rem 0.15rem 0.35rem;
}

#RegisterPage .register-membership-section {
  padding: 0.35rem 0 1rem;
}

#RegisterPage .register-membership-section + .register-membership-section {
  margin-top: 0.35rem;
  padding-top: 1.1rem;
  border-top: 1px solid #e8eef2;
}

#RegisterPage .register-membership-section__title {
  display: flex;
  align-items: center;
  gap: 0.45rem;
  margin: 0 0 0.85rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 800;
  line-height: 1.4;
}

#RegisterPage .register-membership-section__title .fas {
  color: #56508d;
  font-size: 12px;
}

#RegisterPage .register-membership-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  align-items: end;
  gap: 1rem 1.15rem;
}

#RegisterPage .register-membership-section--split .register-membership-fields {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

#RegisterPage .register-membership-field {
  display: flex;
  flex-direction: column;
  grid-column: span 1;
  min-width: 0;
  width: auto;
  max-width: none;
  margin: 0;
}

#RegisterPage .register-membership-field--wide {
  grid-column: span 2;
}

#RegisterPage .register-membership-field--full {
  grid-column: 1 / -1;
}

#RegisterPage .register-membership-label {
  display: block;
  margin-bottom: 0.35rem;
  min-height: 1.25rem;
  color: #29345f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 700;
  line-height: 1.25rem;
  white-space: normal;
}

#RegisterPage .register-membership-field .form-control,
#RegisterPage .register-membership-field select.form-control {
  width: 100%;
  height: 40px;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  color: #13243a;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  text-align: right;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#RegisterPage .register-membership-field .form-control:focus,
#RegisterPage .register-membership-field select.form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
  outline: none;
}

#RegisterPage .register-membership-field .form-control:disabled,
#RegisterPage .register-membership-field select.form-control:disabled {
  color: #6b7b8e;
  background: #f8fafc;
}

#RegisterPage .register-membership-field .form-control[type="number"] {
  -moz-appearance: textfield;
}

#RegisterPage
  .register-membership-field
  .form-control[type="number"]::-webkit-inner-spin-button,
#RegisterPage
  .register-membership-field
  .form-control[type="number"]::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

#RegisterPage .register-membership-field .form-control.text-left,
#RegisterPage .register-membership-field .form-control.required-CodeMeli {
  direction: ltr;
  text-align: left;
}

#RegisterPage .register-membership-field textarea.form-control {
  height: auto;
  min-height: 72px;
  padding-top: 0.65rem;
  padding-bottom: 0.65rem;
  resize: vertical;
}

#RegisterPage .register-membership-fields .vpd-main,
#RegisterPage .vpd-main {
  display: block;
  width: 100%;
}

#RegisterPage .register-membership-fields .vpd-input-group,
#RegisterPage .vpd-input-group {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 40px;
  overflow: hidden;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

#RegisterPage .register-membership-fields .vpd-input-group:focus-within,
#RegisterPage .vpd-input-group:focus-within {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-membership-fields .vpd-input-group input,
#RegisterPage .register-membership-fields .vpd-input-group input.form-control,
#RegisterPage .vpd-input-group input,
#RegisterPage .vpd-input-group input.form-control {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  min-height: 40px;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border: none !important;
  border-radius: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
}

#RegisterPage .register-membership-fields .vpd-input-group input:focus,
#RegisterPage .vpd-input-group input:focus {
  outline: none;
  box-shadow: none !important;
}

#RegisterPage .register-membership-fields .vpd-input-group .vpd-icon-btn,
#RegisterPage .vpd-input-group .vpd-icon-btn {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  min-width: 2.4rem;
  margin: 0 !important;
  padding: 0 0.6rem !important;
  color: #287db4;
  border: none;
  background: #edf5fb;
}

#RegisterPage .register-membership-dropdown-wrap {
  width: 100%;
}

#RegisterPage .register-membership-dropdown-wrap .dropdown {
  width: 100%;
  margin: 0;
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-input {
  display: block;
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  height: 40px;
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  font-weight: 500;
  line-height: 1.5;
  color: #13243a !important;
  text-align: right;
  direction: rtl;
  background: #fff;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
  cursor: pointer;
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-input::placeholder {
  color: #99a6b4;
  font-weight: 400;
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-input:hover {
  background: #fff;
  border-color: #bdcbd4;
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-input:focus {
  outline: none;
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-content {
  right: 0;
  left: 0;
  min-width: 100% !important;
  max-width: none !important;
  margin-top: 0.25rem;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(41, 52, 95, 0.12);
}

#RegisterPage .register-membership-dropdown-wrap .dropdown-item {
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px !important;
  line-height: 1.45 !important;
  padding: 0.55rem 0.75rem !important;
  text-align: right;
  direction: rtl;
}

#RegisterPage .register-membership-field-value {
  min-height: 40px;
  padding: 0.4rem 0.75rem;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
  color: #495057;
  text-align: right;
  background: #f8fafc;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
}

#RegisterPage .register-membership-radio-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
  min-height: 40px;
  padding: 0.35rem 0.75rem;
  background: #fff;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(41, 52, 95, 0.06);
}

#RegisterPage .register-membership-radio.custom-control-inline {
  margin-left: 0;
  margin-right: 0.75rem;
}

#RegisterPage .register-membership-radio .custom-control-label {
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #29345f;
  cursor: pointer;
}

#RegisterPage .register-membership-codemeli-check {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  width: 100%;
}

#RegisterPage .register-membership-codemeli-check .form-control {
  flex: 1 1 auto;
  min-width: 9.5rem;
}

#RegisterPage .register-membership-codemeli-check__btn {
  flex: 0 0 auto;
  align-self: stretch;
  white-space: nowrap;
  min-height: 40px;
}

#RegisterPage .register-membership-codemeli-result {
  margin: 0.45rem 0 0;
  color: #29345f;
  font-size: 12px;
  line-height: 1.6;
}

#RegisterPage .register-membership-codemeli-result span {
  color: #8d58a4;
  font-weight: 700;
}

#RegisterPage .register-membership-docs-note {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 0.45rem 0.65rem;
  margin-bottom: 0.85rem;
  padding: 0.75rem 0.9rem;
  color: #31465f;
  font-family: IRANSansWeb, Tahoma, Arial, sans-serif;
  font-size: 13px;
  line-height: 1.7;
  border: 1px solid #e8eef2;
  border-radius: 12px;
  background: #f8fafc;
}

#RegisterPage .register-membership-docs-note i {
  margin-top: 0.2rem;
  color: #287db4;
}

#RegisterPage .register-membership-docs-note p {
  margin: 0;
  flex: 1 1 16rem;
}

#RegisterPage .register-membership-docs-note a {
  color: #287db4;
  font-weight: 700;
}

#RegisterPage .register-membership-upload-area {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
}

#RegisterPage .register-membership-upload-hint {
  margin: 0;
  color: #7c4a45;
  font-size: 13px;
  line-height: 1.7;
}

#RegisterPage .register-membership-upload-result {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  padding: 0.55rem 0.8rem;
  color: #29345f;
  font-size: 13px;
  border: 1px solid #dbe5eb;
  border-radius: 12px;
  background: #f8fafc;
}

#RegisterPage .register-membership-upload-result i {
  color: #05b8c8;
}

#RegisterPage .register-membership-upload-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.85rem;
}

#RegisterPage .register-membership-upload-card {
  display: flex;
  flex-direction: column;
  gap: 0.7rem;
  min-width: 0;
  padding: 0.9rem;
  border: 1px solid #e8eef2;
  border-radius: 14px;
  background: #f8fafc;
}

#RegisterPage .register-membership-upload-card__title {
  color: #29345f;
  font-size: 13px;
  font-weight: 800;
  line-height: 1.5;
}

#RegisterPage .register-membership-upload-card__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.5rem;
}

#RegisterPage .register-membership-upload-card__meta {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  color: #6b7b8e;
  font-size: 12px;
  line-height: 1.5;
  word-break: break-word;
}

#RegisterPage .register-membership-terms {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  margin: 1rem 0 0;
  padding: 0.85rem 1rem;
  color: #29345f;
  font-size: 13px;
  line-height: 1.8;
  border: 1px solid #e8eef2;
  border-radius: 12px;
  background: #f8fafc;
}

#RegisterPage .register-membership-terms input {
  margin-top: 0.35rem;
  width: 16px;
  height: 16px;
  flex: 0 0 auto;
}

#RegisterPage .register-membership-terms u {
  color: #8d58a4;
  font-weight: 700;
}

#RegisterPage .register-membership-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  width: 100%;
  margin-top: 0.5rem;
  padding: 1rem 0 0.25rem;
  border-top: 1px solid #e8eef2;
  box-sizing: border-box;
}

#RegisterPage .register-membership-actions__captcha {
  flex: 0 1 auto;
  min-width: 0;
  margin-left: auto;
}

#RegisterPage .register-membership-actions__captcha .input-group {
  margin-bottom: 0 !important;
  align-items: stretch;
}

#RegisterPage .register-membership-actions__captcha .form-control {
  height: 44px;
  min-height: 44px;
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
  border: 1px solid #dbe5eb;
  border-radius: 12px 0 0 12px;
  background: #fff;
}

#RegisterPage .register-membership-actions__captcha .form-control:focus {
  border-color: #287db4;
  box-shadow: 0 0 0 3px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-membership-actions__captcha .input-group-text {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 !important;
  border: 1px solid #dbe5eb;
  border-right: 0;
  border-radius: 0 12px 12px 0;
  background: #fff;
}

#RegisterPage .register-membership-actions__captcha .input-group-text img {
  height: 44px;
  width: auto;
}

#RegisterPage .register-membership-page .sv-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: var(--sv-control-h, 40px);
  padding: 6px 14px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.4;
  border-radius: 12px;
  cursor: pointer;
  transition: color 160ms ease, background 160ms ease, border-color 160ms ease,
    box-shadow 160ms ease, transform 160ms ease;
}

#RegisterPage .register-membership-page .sv-btn:focus {
  outline: none;
}

#RegisterPage .register-membership-page .sv-btn:focus-visible {
  box-shadow: 0 0 0 4px rgba(5, 184, 200, 0.2);
}

#RegisterPage .register-membership-page .sv-btn:disabled {
  cursor: not-allowed;
  opacity: 0.6;
  transform: none;
}

#RegisterPage .register-membership-page .sv-btn--icon {
  width: 40px;
  padding: 0;
}

#RegisterPage .register-membership-page .sv-btn--ghost {
  color: #29345f;
  border: 1px solid #dbe5eb;
  background: #fff;
}

#RegisterPage .register-membership-page .sv-btn--ghost:not(:disabled):hover {
  color: #8d58a4;
  border-color: rgba(141, 88, 164, 0.28);
  background: rgba(141, 88, 164, 0.05);
}

#RegisterPage .register-membership-page .sv-btn--primary {
  color: #fff;
  border: 0;
  background: linear-gradient(110deg, #29345f, #56508d 58%, #8d58a4);
  box-shadow: 0 8px 18px rgba(41, 52, 95, 0.16);
}

#RegisterPage .register-membership-page .sv-btn--primary:not(:disabled):hover {
  color: #fff;
  transform: translateY(-1px);
}

#RegisterPage .register-membership-page .sv-btn--wide {
  min-width: 168px;
  min-height: 44px;
}

@media (max-width: 1199px) {
  #RegisterPage .register-membership-fields,
  #RegisterPage
    .register-membership-section--split
    .register-membership-fields {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  #RegisterPage .register-membership-field--wide {
    grid-column: span 1;
  }

  #RegisterPage .register-membership-field--full {
    grid-column: 1 / -1;
  }

  #RegisterPage .register-membership-upload-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 767px) {
  #RegisterPage.register-page {
    padding: 10px 12px 20px;
  }

  #RegisterPage .register-card-shell--membership {
    padding: 0;
  }

  #RegisterPage .register-membership-page--themed .netpa-card__body {
    padding: 0.9rem 0.85rem 1.1rem !important;
  }

  #RegisterPage .register-membership-fields,
  #RegisterPage
    .register-membership-section--split
    .register-membership-fields {
    grid-template-columns: 1fr;
  }

  #RegisterPage .register-membership-field,
  #RegisterPage .register-membership-field--wide,
  #RegisterPage .register-membership-field--full {
    grid-column: span 1;
  }

  #RegisterPage .register-membership-label {
    white-space: normal;
  }

  #RegisterPage .register-membership-codemeli-check {
    flex-direction: column;
    align-items: stretch;
  }

  #RegisterPage .register-membership-codemeli-check .form-control {
    min-width: 0;
    width: 100%;
  }

  #RegisterPage .register-membership-codemeli-check__btn,
  #RegisterPage .register-membership-upload-grid,
  #RegisterPage .register-membership-page .sv-btn--wide {
    width: 100%;
  }

  #RegisterPage .register-membership-upload-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 575px) {
  #RegisterPage .register-membership-actions {
    flex-direction: column;
    align-items: stretch;
  }

  #RegisterPage .register-membership-actions__captcha {
    flex: none;
    width: 100%;
    margin-left: 0;
  }

  #RegisterPage .register-membership-page .sv-btn--wide {
    width: 100%;
  }
}
</style>
<style scoped>
pre {
  font-size: 1.2em !important;
  font-family: IRANSansWeb !important;
}
.EmptyDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 218, 235);
  border: 2px dotted #3161e7;
  border-radius: 15px;
}

.FullDiv {
  width: 100%;
  min-height: 80px;
  background: rgb(184, 235, 205);
  border: 2px dotted #12852f;
  border-radius: 15px;
}

.btn-submit {
  color: blanchedalmond !important;
  background: linear-gradient(
    301deg,
    rgba(145, 124, 193, 1) 0%,
    rgba(72, 20, 193, 1) 100%
  );
  /* background: linear-gradient(301deg, rgba(145, 124, 193, 1) 0%,#403c47 100%); */
}

.btn-submit:hover {
  color: blueviolet !important;
  background: #f8f9fa;
  border: solid 3px rgba(72, 20, 193, 1);
}
</style>
